export default "__VITE_ASSET__CFcqLIuR__"